var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    [
      _vm.state.loading
        ? _c("Loading")
        : _c(
            "Box",
            [
              _c("credit-card", {
                attrs: {
                  gateway: _vm.gateway,
                  testmode: _vm.testMode,
                  currency: _vm.currency,
                  recurring: "",
                  nocvv: _vm.gateway !== "SensePassCardknox"
                }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }